import React from 'react';

import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';
import BoardLength from 'shared/components/parameters/BoardLength';
import BoardWidth from 'shared/components/parameters/BoardWidth';

const BoardSizeInline = (props) => {
  const {
    label,
    required,
    tooltip,
    errorMessageLength,
    errorMessageWidth,
  } = props;

  return (
    <div className="form-group clearfix">
      <Label label={label} required={required} />
      {' '}
      <Tooltip title={tooltip} />
      <div className="d-flex flex-row">
        <div className="flex-fill mr-2">
          <BoardLength
            {...props}
            label={false}
            errorMessage={errorMessageLength} />
        </div>
        <div className="flex-fill">
          <BoardWidth
            {...props}
            label={false}
            errorMessage={errorMessageWidth} />
        </div>
      </div>
    </div>
  );
};

export default BoardSizeInline;
